import { render, staticRenderFns } from "./ModalMaisEventos.vue?vue&type=template&id=69531138&scoped=true"
import script from "./ModalMaisEventos.vue?vue&type=script&lang=js"
export * from "./ModalMaisEventos.vue?vue&type=script&lang=js"
import style0 from "./ModalMaisEventos.vue?vue&type=style&index=0&id=69531138&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69531138",
  null
  
)

export default component.exports